export enum PoliticallyExposedPerson {
  No = 'NO',
  Yes = 'YES',
  Unknown = 'UNKNOWN',
}
